import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { getPlans } from '../supabase/supabase';
import Header from './Header';
import ScrollAnimation from './ScrollAnimation';

function Pricing() {
    const [plans, setPlans] = useState([] as any[]);
    
    useEffect(() => {
        async function fetchPlans() {
            const res = await getPlans();
            if (res === null) return;
            setPlans(res);
        }
        fetchPlans();
    }, []);
    
    return (
        <div className="pricing-page">
            <Header />
            
            {/* Hero Section */}
            <section className="pricing-hero">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto text-center">
                            <ScrollAnimation>
                                <h1 className="pricing-title mb-4">Simple, Transparent Pricing</h1>
                                <p className="pricing-subtitle mb-5">
                                    Choose the perfect plan to keep your family connected with your missionary
                                </p>
                            </ScrollAnimation>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Plans Section */}
            <section className="plans-section py-5">
                <Container>
                    <ScrollAnimation>
                        <Row className="justify-content-center g-4">
                            {plans.map((plan, idx) => (
                                <Col key={idx} lg={4} md={6}>
                                    <PlanCard plan={plan} />
                                </Col>
                            ))}
                        </Row>
                    </ScrollAnimation>
                </Container>
            </section>
        </div>
    );
}

function PlanCard({ plan }: { plan: any }) {
    return (
        <Card className="pricing-card h-100">
            <Card.Body className="d-flex flex-column text-center p-4">
                <h3 className="plan-name mb-3">{plan.name}</h3>
                <div className="price-container mb-4">
                    <span className="price-symbol">$</span>
                    <span className="price-amount">{plan.price}</span>
                    <span className="price-period">/{plan.duration} month{plan.duration > 1 ? 's' : ''}</span>
                </div>
                <Button className="plan-button mt-auto" size="lg" onClick={() => { window.location.href = '/login'; }}>
                    Get Started
                </Button>
            </Card.Body>
        </Card>
    );
}

export default Pricing;
